export default __webpack_public_path__ + "static/media/lid_shelf.63a9e321.svg";